import { IBookingsByOwnerIdParams, IBookingsByPropertyIdParams, IBookingsStatisticsByOwnerIdParams } from './bookings';

type IParams = IBookingsByOwnerIdParams | IBookingsByPropertyIdParams | IBookingsStatisticsByOwnerIdParams | undefined;

export function normaliseQueryParameters(params: IParams = {}) {
	return Object.entries(params).reduce((acc, [key, value]) => {
		let returnVal = value;
		if (Array.isArray(value)) {
			returnVal = value.join();
		}
		return { ...acc, [key]: returnVal };
	}, {});
}

export function queryParametersToQueryString(params: IParams = {}) {
	return Object.entries(params).reduce((acc, [key, value], index) => {
		return `${acc}${index !== 0 ? '&' : ''}${key}=${value}`;
	}, '');
}
